/**
 * The store.
 *
 * Four slices, no persistence middleware. The basket deliberately does *not*
 * survive a reload: an unsaved ticket restored from local storage after a crash
 * would look authoritative while having no order behind it, and a cashier would
 * settle a bill that was never written. Anything worth keeping is held on the
 * server as a held order, which is what the Recall screen reads.
 */

import { configureStore } from '@reduxjs/toolkit';

import authReducer from './authSlice';
import cartReducer from './cartSlice';
import menuReducer from './menuSlice';
import uiReducer from './uiSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        cart: cartReducer,
        menu: menuReducer,
        ui: uiReducer
    },
    middleware: (getDefault) =>
        getDefault({
            serializableCheck: {
                // Date objects travel in report filters; they are serialisable
                // enough for our purposes and warning about them is noise.
                ignoredActionPaths: ['payload.fromDate', 'payload.toDate', 'meta.arg'],
                ignoredPaths: ['ui.confirmDialog.onConfirm']
            }
        }),
    devTools: import.meta.env.DEV
});

export default store;
